import { BaseReactComponent } from "@/Common/Components/BaseReactComponent";

interface IBasePreventiveActivitiesDisplayItemsPopup {
    id: string;
    positionLeft: number;
    positionTop: number;
    onClosed: () => void;
    cssStyle?: React.CSSProperties;
}

abstract class BasePreventiveActivitiesDisplayItemsPopup<TProps extends IBasePreventiveActivitiesDisplayItemsPopup, TState> extends BaseReactComponent<TProps, TState> {
    protected abstract getHeader(): string;
    protected abstract getBody(): React.ReactNode;
    protected abstract shouldTriggerOkActionOnOutsideClick(): boolean;

    public componentDidMount(): void {
        super.setOverlay(
            this.props.id,
            {
                transparent: true,
                onClicked: () => this.shouldTriggerOkActionOnOutsideClick() && this.props.onClosed()
            }
        );
    }

    public render(): JSX.Element {
        const listCss: React.CSSProperties = {
            ...this.props.cssStyle,
            position: "absolute",
            left: `${this.props.positionLeft}px`,
            top: `${this.props.positionTop}px`
        };

        return (
            <div className="attachments-popup" style={listCss}>
                <div className="notes-dropdown-content">
                    <h3>{this.getHeader()}</h3>
                    <div key={this.props.id}>
                        {this.getBody()}
                    </div>
                </div>
            </div>
        );
    }
}

export { BasePreventiveActivitiesDisplayItemsPopup, IBasePreventiveActivitiesDisplayItemsPopup };
